import type { DocumentPlace } from '../types';

import { API } from 'app/api';

// ---

export function getDocumentApiService(place: DocumentPlace) {
  switch (place) {
    case 'privacy_policy':
      return API.strapiServices.documents.getPrivacyPolicy;
    case 'aml_manual':
      return API.strapiServices.documents.getAMLManual;
    case 'general_terms':
      return API.strapiServices.documents.getGeneralTerms;
    case 'responsible_gaming':
      return API.strapiServices.documents.getResponsibleGaming;
    case 'terms_of_service':
      return API.strapiServices.documents.getTermsOfService;
    default:
      assertExhaustiveness(place);
  }
}
